import React from "react";
import { motion } from "framer-motion";
import { Icon } from "./icon";

export const About = (props) => {
  const data = props.data;

  return (
    <section id="about" className="section bg-white">
      <div className="container">
        <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-12 lg:gap-20">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="relative lg:col-span-5"
          >
            {/* Offset navy plate behind the photo */}
            <div
              className="absolute -bottom-5 -left-5 h-full w-full rounded-3xl border border-navy-100 bg-navy-50"
              aria-hidden="true"
            />

            <div className="relative overflow-hidden rounded-3xl shadow-lift">
              <img
                src="img/about.jpg"
                alt="The Mercuri team at work"
                loading="lazy"
                className="aspect-[4/5] w-full object-cover"
              />
              <div
                className="absolute inset-0 bg-gradient-to-t from-navy-950/45 via-transparent to-transparent"
                aria-hidden="true"
              />
            </div>

            {/* Experience badge */}
            {data && data.since && (
              <div className="absolute -right-4 bottom-8 rounded-2xl border border-line bg-white px-6 py-5 shadow-lift lg:-right-8">
                <span className="block font-display text-3xl font-extrabold text-crimson-600">
                  {data.since}
                </span>
                <span className="mt-1 block text-xs font-semibold uppercase tracking-[0.14em] text-ink-muted">
                  Building since
                </span>
              </div>
            )}
          </motion.div>

          {/* Copy */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-7"
          >
            <span className="eyebrow">{data ? data.eyebrow : "About Mercuri"}</span>
            <h2 className="section-heading mt-6">
              {data ? data.title : "A product team, not a body shop"}
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-ink-muted">
              {data ? data.paragraph : ""}
            </p>

            <div className="hairline my-10" />

            <h3 className="text-sm font-bold uppercase tracking-[0.14em] text-navy-900">
              Why teams choose us
            </h3>

            <ul className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {(data ? data.Why : []).map((d, i) => (
                <motion.li
                  key={d}
                  initial={{ opacity: 0, y: 14 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.07, duration: 0.5 }}
                  className="group flex items-start gap-3 rounded-xl border border-transparent p-3 transition-colors duration-300 hover:border-line hover:bg-navy-50/60"
                >
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-crimson-50 text-crimson-600 ring-1 ring-inset ring-crimson-100 transition-colors duration-300 group-hover:bg-crimson-600 group-hover:text-white group-hover:ring-crimson-600">
                    <Icon name="check" className="h-3.5 w-3.5" strokeWidth="2.5" />
                  </span>
                  <span className="text-[0.95rem] font-medium leading-relaxed text-ink-soft">
                    {d}
                  </span>
                </motion.li>
              ))}
            </ul>

            <a href="#contact" className="btn-outline group mt-10">
              Talk to the team
              <Icon
                name="arrowRight"
                className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
              />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
